import { getMessages } from '../../../../../../../store/constants';

export const DELETE_TEXT_TOOLTIP_VALUE = getMessages().getText('card_form_action_delete');

export const SNACKBAR_CARD_ARCHIVE_ID = 'SNACKBAR_CARD_ARCHIVE_ID';
export const SNACKBAR_CARD_DELETE_ID = 'SNACKBAR_CARD_DELETE_ID';
export const SNACKBAR_CARD_DELETE_TEXT = 'card_form_snackbar_delete_text';
